var React = require('react');
var Rating = require('./Rating');

module.exports = React.createClass({
  contextTypes: function() {
    executeAction: React.PropTypes.func
  },
  getInitialState: function() {

    return this.state = {
      page: 10,
      data: this.props.entities

    };
  },
  handleClick: function(entity) {
    $('.pagination li a').removeClass('activePagination');
    $('#' + entity.id + '').addClass('activePagination');
    var currentPagination = entity.id * 10;
    return this.replaceState({
      page: currentPagination
    });
  },
  componentDidMount: function() {
    $('#1').addClass('activePagination');
  },
  handleSort: function() {
    var temp = this.state.data;

    if (this.refs.reviewSort.getDOMNode().value == "date") {
      temp.sort(function(a, b) {
        return new Date(a.reviewed_on) - new Date(b.reviewed_on);
      });
    } else if (this.refs.reviewSort.getDOMNode().value == "ratings") {
      temp.sort(function(a, b) {
        return b.review_rating.slice(0, 1) - a.review_rating.slice(0, 1);
      });
    }
    this.setState({
      data: temp
    });
  },
  leftPagination: function(entity) {
    var currentPageId = $('.activePagination').attr('id');
    currentPageId--;
    if (currentPageId > 0) {
      $('.pagination li a').removeClass('activePagination');
      $('#' + currentPageId + '').addClass('activePagination');
      if (parseInt($('.pagination').css('left').replace('px', '')) < 0) {
        $('.pagination').css('left', (parseInt($('.pagination').css('left').replace('px', '')) + parseInt($('#' + (currentPageId) + '').css('width').replace('px', '')) + 'px'));
      }
      var currentPagination = currentPageId * 10;
      return this.replaceState({
        page: currentPagination
      });
    }
  },
  rightPagination: function(entity) {
    var currentPageId = $('.activePagination').attr('id');
    currentPageId++;
    var entitylength = Math.ceil(this.props.entities.length / 10);
    if (currentPageId <= entitylength) {
      $('.pagination li a').removeClass('activePagination');
      $('#' + currentPageId + '').addClass('activePagination');
      if (parseInt($('.pagination').css('left').replace('px', '')) <= 0) {
        $('.pagination').css('left', (parseInt($('.pagination').css('left').replace('px', '')) - parseInt($('#' + (currentPageId) + '').css('width').replace('px', '')) + 'px'));
      }
      var currentPagination = currentPageId * 10;
      return this.replaceState({
        page: currentPagination
      });
    }
  },
  render: function(entity) {
    var profile = this.state.data;
    var currentPage = this.state.page;
    var paginationlength = Math.ceil(profile.length / 10);
    var indents = [];
    var pages = 0;
    for (var i = 0; i < paginationlength; i++) {
      pages++;
      indents.push({
        id: pages
      });
    }
    return (
      <div>
        <div className="review-option-container">
          <span className="option-name">Sort by: <select className="review-options" ref="reviewSort" onChange={ this.handleSort.bind(this) }><option value="none">SELECT</option><option value="date">Date</option><option value="ratings">Ratings</option></select></span>
        </div>
        { profile.map(function(profile, index) {
            return (
              <div>
                { ((null !== profile.review_description) && ((index >= currentPage - 10) && (index <= currentPage))) && (
                  <div className="row-fluid">
                    <div className="userreview-container" style={ { "position": "relative" } }>
                      <div>
                        <div className="review-detail profilereview-detail" style={ { "padding": "0em" } }>
                          <div className="review-expert-description profilereview-description">
                            { profile.review_description.replace(/(?:\\r|\\n|\\)+/g, "") }
                          </div>
                          <div className="review-expert-detail profilereview-rating" style={ { "float": "right" } }>
                            { (null !== profile.reviewed_on) && (
                              <div style={ { "text-align": "center" } }>
                                { profile.reviewed_on.replace("Reviewed ", "") }
                              </div>
                              ) }
                            <div style={ { "padding-top": "1em", "text-align": "center" } }>
                              <Rating entities={ { rating: JSON.parse(profile.review_rating.slice(0, 1)) } } />
                            </div>
                          </div>
                        </div>
                        <div className="userreview-rating">
                          { profile.display_name }
                        </div>
                      </div>
                    </div>
                  </div>
                  ) }
              </div>
              );
          }) }
        { (null !== profile[0].review_description) && (
          <div className="pagination-container">
            <i className="sprite-red sprite-Left-Chevron-Copy" onClick={ this.leftPagination.bind(this) } style={ { "position": "relative", "float": "left", "cursor": "pointer" } }></i>
            <div className="clearfix pagination-ul-wrap">
              <ul className="pagination service-pagination">
                { indents.map(function(entity, index) {
                    var boundclick = this.handleClick.bind(this, entity);
                    return (
                      <li style={ { "cursor": "pointer" } }>
                        <a id={ entity.id } onClick={ boundclick }>
                          { entity.id }
                        </a>
                      </li>
                      );
                  }, this) }
              </ul>
            </div>
            <i className="sprite-red sprite-Right-Chevron-Copy" onClick={ this.rightPagination.bind(this) } style={ { "position": "relative", "float": "left", "cursor": "pointer" } }></i>
          </div>
          ) }
      </div>
      );
  }
});




// WEBPACK FOOTER //
// ./src/components/ProfileReview.js